import React from 'react';
import PropTypes from 'prop-types';

import { EditIcon } from 'common/icons';

const PartnerTagsCell = ({ partnerAccounts, onEdit, onRemove }) => {
  const stopRowEvent = event => {
    event.stopPropagation();
  };

  return (
    <div className="PartnerTagsCell">
      {(partnerAccounts || []).map(account => (
        <div className="PartnerTagsCell__account" key={account.id}>
          <span className="PartnerTagsCell__partner-code">{account.partnerCode || account.partner_code}</span>
          <div className="PartnerTagsCell__tags">
            {(account.tags || []).map(tag => (
              <span className="PartnerTagsCell__tag" key={tag.id}>
                <span>{tag.name}</span>
                <button
                  type="button"
                  aria-label={`Remove ${tag.name}`}
                  onClick={event => {
                    stopRowEvent(event);
                    onRemove(account.id, tag);
                  }}>
                  <span className="PartnerTagsCell__tag-remove" />
                </button>
              </span>
            ))}
          </div>
          <button
            className="PartnerTagsCell__edit"
            type="button"
            aria-label={`Edit tags for ${account.partnerCode || account.partner_code}`}
            onPointerDown={stopRowEvent}
            onMouseDown={stopRowEvent}
            onClick={event => {
              stopRowEvent(event);
              onEdit(account);
            }}>
            <EditIcon />
          </button>
        </div>
      ))}
    </div>
  );
};

PartnerTagsCell.propTypes = {
  partnerAccounts: PropTypes.array,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

PartnerTagsCell.defaultProps = {
  partnerAccounts: [],
};

export default PartnerTagsCell;
export { PartnerTagsCell };
